import { i18nConfig } from 'es2015-i18n-tag'
import translations from './translation.en.json'

i18nConfig({
	locales: 'en',
	group: 'en',
	number: {
		currency: 'EUR',
	},
	translations,
})
